module.exports = __webpack_public_path__ + "static/img/banner_2.c1bd075c.png";